var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunicationTower = function SvgCommunicationTower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m11.041 7.013 3.38 2.454-.315-.723-3.065-2.236zM8.608 22.089h.947l1.486-15.58v-.521h-.823z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.633 10.118 4.076 2.914-.11-.703-3.904-2.797z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M16.384 22.089h-.946L13.95 6.509v-.521h.823z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m10.353 13.442 4.814 3.596-.1-.805-4.714-3.482z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M10.851 3.183h3.255v3.285h-3.255z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m9.947 17.544 5.546 4.003-.094-.765-5.34-3.873zM14.06 7.013l-3.38 2.454.314-.723 3.065-2.236zM14.347 10.118l-4.075 2.914.11-.703 3.904-2.797z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "m14.806 13.442-4.814 3.596.1-.805 4.714-3.482zM15.131 17.544l-5.546 4.003.094-.765 5.34-3.873z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M15.192 7.508a2.732 2.732 0 0 0 2.17-2.682 2.732 2.732 0 0 0-2.17-2.683c.175-.036.357-.054.542-.054 1.499 0 2.713 1.225 2.713 2.737 0 1.511-1.214 2.737-2.713 2.737-.185 0-.367-.02-.542-.055"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M17.724 7.508a2.732 2.732 0 0 0 2.17-2.682 2.732 2.732 0 0 0-2.17-2.683c.175-.036.356-.054.542-.054 1.499 0 2.713 1.225 2.713 2.737 0 1.511-1.214 2.737-2.713 2.737-.186 0-.367-.02-.542-.055M7.234 7.508a2.732 2.732 0 0 1-2.17-2.682c0-1.325.932-2.429 2.17-2.683a2.702 2.702 0 0 0-.542-.054c-1.498 0-2.713 1.225-2.713 2.737 0 1.511 1.215 2.737 2.713 2.737.186 0 .367-.02.542-.055"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M9.766 7.508a2.732 2.732 0 0 1-2.17-2.682c0-1.325.932-2.429 2.17-2.683a2.702 2.702 0 0 0-.542-.054c-1.499 0-2.713 1.225-2.713 2.737 0 1.511 1.214 2.737 2.713 2.737.185 0 .367-.02.542-.055"
  })));
};
export default SvgCommunicationTower;